// extracted by mini-css-extract-plugin
export default {"bigHeading":"Page_bigHeading__Ca4ax","pageTitle":"Page_pageTitle__SvRTa","bigButton":"Page_bigButton__C3YqR","links":"Page_links__JNVJH","definitions":"Page_definitions__ZZuTV"};